<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-refresh
                                @invoke-method="getMyOrgs()"
                            ></bc-btn-refresh>

                            <bc-btn-mobile-nav
                                @invoke-method="invokeMethod($event)"
                                :mobile-list="mobileList"
                            ></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table
                        :headers="headers"
                        :items="companies"
                        hide-actions
                        :no-data-text="$t('lang.no_data_available')"
                    >
                        <template slot="items" slot-scope="props">
                            <td class="clickable" @mouseup.left="openTokens(props.item.company_id)">{{ props.item.company }}</td>
                            <td class="clickable" @mouseup.left="openTokens(props.item.company_id)">{{ props.item.relation }}</td>
                            <td class="px-0"><v-btn @mouseup.left="openCreateToken(props.item)" color="success" v-if="props.item.owner == '1'">{{ $t('lang.create') }}</v-btn></td>
                            <td class="px-0"><v-btn @mouseup.left="openLeaveCompany(props.item)" color="error">{{ $t('lang.leave') }}</v-btn></td>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-container>
        <bc-dialog v-model="createTokenDialog">
            <v-card>
                <v-card-title>
                    <span class="headline">{{$t('lang.create_token')}}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="createTokenDialog"
                        :dialog-status="createTokenDialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="create_token_form">
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-text-field
                                        v-model="create_token.name"
                                        :label="`${$t('lang.name')} *`"
                                        :counter="showCounter(create_token.name, 'user.token_name')"
                                        :rules="ifValid('user.token_name')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <bc-phone-input
                                        :update-object="create_token"
                                        :label="`${$t('lang.phone_number')} *`"
                                        :rules="ifValid('user.phone_number')"
                                    ></bc-phone-input>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="createTokenDialog = false">{{$t('lang.cancel')}}</v-btn>
                    <v-btn color="success" @mouseup.left="createToken()">{{$t('lang.create_token')}}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <v-dialog v-model="leaveOrgDialog" persistent scrollable max-width="500">
            <v-card>
                <v-card-title>
                    <span class="headline">{{$t('lang.leave')}}: {{ current_leave_company_name }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="leaveOrgDialog"
                        :dialog-status="leaveOrgDialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-form>
                        <v-layout row wrap>
                            <v-flex xs12>
                                {{ $t('lang.confirm_leave_company') }}
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="leaveOrgDialog = false">{{ $t('lang.cancel') }}</v-btn>
                    <v-btn color="error" @mouseup.left="leaveOrg(current_leave_company_id)">{{ $t('lang.leave') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="accessTokensDialog">
            <v-card>
                <v-card-title>
                    <span class="headline">{{$t('lang.access_tokens')}}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="accessTokensDialog"
                        :dialog-status="accessTokensDialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-data-table
                        :headers="access_tokens_headers"
                        :items="filtered_tokens"
                        hide-actions
                        :no-data-text="$t('lang.no_data_available')"
                    >
                        <template slot="items" slot-scope="props">
                            <td>{{ props.item.user }}</td>
                            <td class="text-center" :class="!props.item.date_revoked ? 'green--text' : false">{{ props.item.date_issued }}</td>
                            <td class="red--text text-center" v-if="props.item.date_revoked">{{ props.item.date_revoked }}</td>
                            <td v-else>
                                <v-container grid-list-form>
                                    <v-layout row wrap>
                                        <v-flex :xs6="confirmRevoke == props.index" style="align-content: center">
                                            <v-btn icon :color="confirmRevoke == props.index ? null : 'error'" @mouseup.left="confirmRevoke == props.index ? confirmRevoke = null : confirmRevoke = props.index"><v-icon :style="confirmRevoke == props.index ? null : 'margin-left:-1px'">{{ confirmRevoke == props.index ? 'close' : 'delete'}}</v-icon></v-btn>
                                        </v-flex>
                                        <v-flex xs6 v-if="confirmRevoke == props.index">
                                            <v-btn icon color="success" @mouseup.left="revokeAccess(props.item)"><v-icon>check</v-icon></v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </td>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";

export default {
    components: {
        //toolbar
    },
    data() {
        return {
            access_tokens_headers: [
                { text: this.$t("lang.name"), sortable: false },
                { text: this.$t("lang.issued"), sortable: false, align: "center", width: "150" },
                { text: this.$t("lang.revoked"), sortable: false, align: "center", width: "150" },
            ],
            headers: [
                { text: this.$t("lang.company_id"), sortable: false },
                { text: this.$t("lang.relationship"), sortable: false },
                { text: "", sortable: false, align: "center", width: "100" },
                { text: "", sortable: false, align: "center", width: "100" },
            ],
            companies: [],
            user_tokens: [],
            user: [],
            current_company: 0,
            current_leave_company_id: false,
            current_leave_company_name: false,
            leaveOrgDialog: false,
            createTokenDialog: false,
            validCreateToken: false,
            current_create_company_id: false,
            accessTokensDialog: false,
            revoke_access_id: false,
            confirmRevoke: null,
            create_token: { name: "" },
            mobileList: [{ title: this.$t("lang.refresh"), action: "getMyOrgs" }],
        };
    },
    beforeRouteEnter(to, from, next) {
        const companies = new Promise((resolve, reject) => {
            store
                .dispatch("fetchMe", {
                    url: "me/companies?with_tokens=1",
                    method: "get",
                })
                .then((data) => {
                    typeof data !== "undefined" ? resolve(data.companies) : reject(new Error("reject"));
                });
        });

        const user_tokens = new Promise((resolve, reject) => {
            store
                .dispatch("fetchUserTokens", {
                    url: "user_tokens",
                    method: "get",
                })
                .then((data) => {
                    typeof data !== "undefined" ? resolve(data.user_tokens) : reject(new Error("reject"));
                });
        });

        Promise.all([companies, user_tokens])
            .then(([companies, user_tokens]) => {
                next((vm) => {
                    vm.companies = companies;
                    vm.user_tokens = user_tokens;
                    vm.finishLoader();
                });
            })
            .catch((error) => {
                next({ name: "dashboard", replace: true }); //if any of them error, don't go to route, else set variables and proceed to route
            });
    },
    beforeRouteUpdate(to, from, next) {
        const companies = new Promise((resolve, reject) => {
            this.$store
                .dispatch("fetchMe", {
                    url: "me/companies?with_tokens=1",
                    method: "get",
                })
                .then((data) => {
                    typeof data !== "undefined" ? resolve(data.companies) : reject(new Error("reject"));
                });
        });

        const user_tokens = new Promise((resolve, reject) => {
            this.$store
                .dispatch("fetchUserTokens", {
                    url: "user_tokens",
                    method: "get",
                })
                .then((data) => {
                    typeof data !== "undefined" ? resolve(data.user_tokens) : reject(new Error("reject"));
                });
        });

        Promise.all([companies, user_tokens])
            .then(([companies, user_tokens]) => {
                this.companies = companies;
                this.user_tokens = user_tokens;
                this.finishLoader();
                next();
            })
            .catch((error) => {
                next({ name: "dashboard", replace: true }); //if any of them error, don't go to route, else set variables and proceed to route
            });
    },
    computed: {
        ...mapState({
            rules_user: (state) => state.validation.rules_user,
            user_token: (state) => state.validation.user_token,
        }),
        filtered_tokens() {
            return this.user_tokens.filter((token) => token.company_id == this.current_company);
        },
    },
    methods: {
        getMyOrgs() {
            this.startLoader();

            this.$store
                .dispatch("fetchMe", {
                    url: "me/companies?with_tokens=1",
                    method: "get",
                })
                .then((data) => {
                    this.companies = data.customers;
                })
                .finally(() => {
                    this.finishLoader(true);
                    this.leaveOrgDialog = false;
                    this.createTokenDialog = false;
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        openLeaveCompany(item) {
            this.current_leave_company_name = item.company;
            this.current_leave_company_id = item.company_id;
            this.leaveOrgDialog = true;
        },
        leaveOrg(id) {
            this.$store.commit("toggleModalLoader", true);
            this.$nextTick(() => {
                this.$store
                    .dispatch("fetchMe", {
                        url: "me/companies/" + id + "/leave",
                        method: "patch",
                    })
                    .then((data) => {
                        this.getMyOrgs();
                    });
            });
        },
        getTokens() {
            this.$store
                .dispatch("fetchUserTokens", {
                    url: "user_tokens",
                    method: "get",
                })
                .then((data) => {
                    this.user_tokens = data.user_tokens;
                })
                .finally(() => this.$store.commit("toggleModalLoader", false));
        },
        revokeAccess(token) {
            this.$store.commit("toggleModalLoader", true);
            this.$store
                .dispatch("fetchUserTokens", {
                    url: "user_tokens/" + token.token_id + "/revoke",
                    method: "patch",
                    body: {
                        company_id: token.company_id,
                        user_id: token.user_id,
                    },
                })
                .then((data) => {
                    this.getTokens();
                });
        },
        openCreateToken(item) {
            this.current_create_company_id = item.company_id;
            this.createTokenDialog = true;
        },
        createToken() {
            this.$store.commit("validationOn");
            this.$nextTick(() => {
                if (this.validateForm("create_token_form")) {
                    this.$store.commit("toggleModalLoader", true);
                    this.create_token.company_id = this.current_create_company_id;
                    this.$store
                        .dispatch("fetchUserTokens", {
                            url: "user_tokens/",
                            method: "post",
                            stateProperty: "user_tokens",
                            dataProperty: "user_token",
                            commit: true,
                            body: this.create_token, //TODO: is name variable right
                        })
                        .then((data) => {
                            if (data && data.code == "200") {
                                this.$store.commit("validationOff");
                                this.createTokenDialog = false;
                            } else {
                                console.log(data);
                                this.$store.commit("toggleModalLoader", false);
                            }

                            // this.getMyOrgs();
                        });
                }
            });
        },
        openTokens(id) {
            this.current_company = id;
            this.accessTokensDialog = true;
        },
    },
};
</script>
